import React from "react";
import { Grid, Button } from "@material-ui/core";
import "react-datepicker/dist/react-datepicker.css";

import { UploadSection } from "./UploadResumeComponent.styled";

const UploadResumeComponent = ({ answer }) => {
  const handleDetectFile = (extension) => {
    switch (extension) {
      case ".jpg":
        return true;
      case "jpeg":
        return true;
      case ".pdf":
        return true;
      default:
        return false;
    }
  };

  const detectAnswerType = () => {
    return handleDetectFile(
      answer?.substring(answer.length - 4, answer.length).toLowerCase()
    );
  };

  return detectAnswerType() ? (
    <UploadSection>
      <Grid container style={{ display: "flex", alignItems: "center" }}>
        <Grid item style={{ paddingRight: "5px" }}>
          <Button
            disabled={true}
            size="small"
            style={{ textTransform: "none" }}
          >
            Upload file
          </Button>
        </Grid>
        <Grid item>{answer}</Grid>
      </Grid>
    </UploadSection>
  ) : (
    <>
      <p>{answer}</p>
    </>
  );
};

export default UploadResumeComponent;
